import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  resource,
} from '@angular/core';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
  DvSpinnerComponent,
} from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentsService } from '@shared/services/attachments.service';
import { firstValueFrom } from 'rxjs';

export interface FullImageDialogData {
  attachmentId: number;
}

@Component({
  selector: 'app-image-preview-dialog',
  imports: [
    DvDialogContentComponent,
    DvButtonComponent,
    TranslateModule,
    DvSpinnerComponent,
    TranslateModule,
  ],
  templateUrl: './image-preview-dialog.component.html',
  styleUrl: './image-preview-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewDialogComponent extends DvDialogContent<
  FullImageDialogData,
  ImagePreviewDialogComponent
> {
  private attachmentService = inject(AttachmentsService);

  imageUrlResource = resource({
    params: () => this.data.attachmentId,
    loader: async ({ params }) => {
      if (!params) return null;

      return await firstValueFrom(
        this.attachmentService.getAttachmentUrl(params, true)
      );
    },
  });

  imageSrc = computed(() => {
    if (this.imageUrlResource.hasValue()) {
      return this.imageUrlResource.value();
    }
    return null;
  });

  constructor() {
    super();
  }
}
